import { initializeApp } from "firebase/app";
import { getDatabase, ref, onValue, query, orderByChild, equalTo, update, remove, set, push, off, get } from "firebase/database";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyBdjOpQioFT8N2AZI0iseaZhQn7C1-kyCM",
    authDomain: "helmysherif-6609c.firebaseapp.com",
    databaseURL: "https://helmysherif-6609c-default-rtdb.firebaseio.com",
    projectId: "helmysherif-6609c",
    storageBucket: "helmysherif-6609c.firebasestorage.app",
    messagingSenderId: "1038088786441",
    appId: "1:1038088786441:web:1e8534b918452b340c5ed8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getDatabase(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

export { db, auth, googleProvider, ref, onValue, query, orderByChild, equalTo, update, remove, set, push, off, get };
